import { render, staticRenderFns } from "./NewDiscard.vue?vue&type=template&id=64dcef1f&scoped=true&"
import script from "./NewDiscard.vue?vue&type=script&lang=js&"
export * from "./NewDiscard.vue?vue&type=script&lang=js&"
import style0 from "./NewDiscard.vue?vue&type=style&index=0&id=64dcef1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcef1f",
  null
  
)

component.options.__file = "NewDiscard.vue"
export default component.exports